define('taoBackOffice/controller/routes',[],function () {
    'use strict';

    return {
        'Lists' : {
            'actions' : {
                'index' : 'controller/list/index'
            }
        },
        'Trees': {
            'actions': {
                'viewTree': 'controller/tree/view'
            }
        }
    };
});

